import React, { Component } from "react";
import { connect } from "react-redux";
import { actionCreators as authActions } from "../redux/actions/authActions";
import { actionCreators as staticDataActions } from "../redux/actions/staticDataActions";
import { bindActionCreators } from "redux";
import * as authHelpers from '../authentication/authHelpers';

export default function (ComposedComponent) {
    class PrivateGuard extends Component {
        constructor(props) {
            super(props);

            this.state = {
                configurationSettings: null
            };

            this.initialiseComponent();
        }

        initialiseComponent = () => {
            let user = authHelpers.getAuthUser();

            if (!user) {
                const accountUniqueName = authHelpers.getAccountUniqueNameFromUrl();
                const params = new URLSearchParams(this.props.location.search);
                let accessToken = params.get('access_token');

                if (accessToken) {
                    this.setUserOnLocalStorage(params, accessToken, accountUniqueName);
                    this.fetchAndStoreConfigurationSettings(accountUniqueName);
                }

                user = authHelpers.getAuthUser();
            }

            const route = !user
                ? '/login'
                : !user.consent
                    ? '/acceptance-of-terms'
                    : '';

            if (route !== '' && !this.props.location.pathname.endsWith(route)) {
                this.props.history.push(authHelpers.buildRouteWithAuthParams(route, new URLSearchParams(this.props.location.search)));
            }
        };

        fetchAndStoreConfigurationSettings = (accountUniqueName) => {
            (async () => {
                try {
                    const configurationSettings = await this.props.requestConfigurationSettings(accountUniqueName);
                    this.setState({ configurationSettings: configurationSettings });
                } catch (error) {
                    console.error("Failed to fetch configuration settings", error);
                }
            })();
        };

        setUserOnLocalStorage(params, accessToken, accountUniqueName) {
            const userFullName = params.get('user_name');

            authHelpers.setAuthUser({
                name: userFullName,
                token: accessToken,
                accountName: accountUniqueName,
                configurationSettings: this.state.configurationSettings
            });
        }

        render() {
            return <ComposedComponent
                {...this.props}
                configurationSettings={this.state.configurationSettings} />;
        }
    }

    return connect(
        (state) => state.authentication,
        (dispatch) => bindActionCreators({ ...authActions, ...staticDataActions }, dispatch)
    )(PrivateGuard);
}
